<lib-base-card>
  <div
    class="teaser-image-wrapper"
    [style.height]="imageHeight || '200px'"
    (click)="imageClicked.emit()"
  >
    <lib-animated-discount-icon
      *ngIf="!!discountProducts?.length"
    ></lib-animated-discount-icon>
    <img alt="salon-image" [src]="image" />
  </div>

  <div class="card-content-container">
    <div (click)="bodyClicked.emit()">
      <ng-container *ngIf="bonusPoints; else basicInfoTemplate">
        <div class="flex-row-break-on-tablet">
          <div>
            <ng-container [ngTemplateOutlet]="basicInfoTemplate"></ng-container>
          </div>

          <lib-spacer></lib-spacer>

          <div class="bonus-point-label">
            {{ bonusPoints }} {{ 'salon-card.text.points' | translate }}
          </div>
        </div>
      </ng-container>

      <ng-content select="[body]"></ng-content>

      <ng-container *ngIf="!!discountProducts?.length">
        <lib-spacer [height]="10"></lib-spacer>
        <lib-divider></lib-divider>
        <lib-spacer [height]="10"></lib-spacer>

        <ng-container
          *ngFor="
            let discountProduct of discountProducts.slice(
              0,
              NUMBER_OF_DISCOUNT_PRODUCT_TO_SHOW
            )
          "
        >
          <div class="flex-row-space-between">
            <div>{{ discountProduct.name }}</div>
            <div style="text-align: end; min-width: 70px">
              <div class="original-price-label description">
                {{ discountProduct.price | roundNumberFormatter }}
                {{ salonCurrency }}
              </div>
              <div class="highlight-text" style="margin-left: 5px">
                {{ getDiscountPrice(discountProduct) | roundNumberFormatter }}
                {{ salonCurrency }}
              </div>
            </div>
          </div>

          <lib-spacer [height]="5"></lib-spacer>
        </ng-container>

        <div
          *ngIf="discountProducts?.length > NUMBER_OF_DISCOUNT_PRODUCT_TO_SHOW"
          class="description"
          style="text-align: end"
        >
          {{
            'salon-card.text.and-x-more'
              | translate : { nr: discountProducts?.length - 2 }
          }}
        </div>
      </ng-container>
    </div>

    <lib-spacer [height]="10"></lib-spacer>
    <lib-divider></lib-divider>
    <lib-spacer [height]="10"></lib-spacer>

    <ng-content select="[footer]"></ng-content>
  </div>
</lib-base-card>

<ng-template #basicInfoTemplate>
  <h1>{{ salonName }}</h1>
  <div>{{ salonAddress }}</div>
</ng-template>
